export type YearType = 'Calendar' | 'Fiscal' | 'Other';

export const YEAR_TYPES: YearType[] = ['Calendar', 'Fiscal', 'Other'];
